import { FuseAnimate } from "@fuse";
import _ from "@lodash";
import { Button, Card, CardContent, TextField, withStyles } from "@material-ui/core";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import FirebaseAuthService from "app/Core/services/FirebaseAuthService";
import * as AppActions from "app/store/actions";
import classNames from "classnames";
import clsx from "clsx";
import React from "react";
import connect from "react-redux/es/connect/connect";
import { Link, withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";

const styles = theme => ({
    root: {
        background: theme.palette.type === "dark" ? "#424242" : "#E6E6E6",
        color: theme.palette.primary.contrastText
    },
    paper: {
        width: "70%",
    },
    card: {
        background: theme.palette.type === "dark" ? "#494949" : "#FFFFFF",
        color: theme.palette.type === "dark" ? "#FFFFFF" : "#494949",
    },
    content: {
        background: theme.palette.type === "dark" ? "#424242" : "#E6E6E6",
        color: theme.palette.type === "dark" ? "#CCC" : "#666",
        border: "1px solid " + theme.palette.divider,
        borderRadius: 10,
    },
    image: {
        display: "flex",
        "@media (max-width: 960px)": {
            display: "none"
        }
    },
    bgTheme: {
        backgroundColor: theme.palette.primary.main
    }
});

class ResetPasswordPage extends XAPPComponent {

    state = {
        email: "",
    };

    isFormValid = () => {
        const form = this.state;
        return (
            form.email.length > 0
        );
    };

    handleChange = (event) => {
        this.setState(_.set({ ...this.state }, event.target.name, event.target.value));
    };

    handleSubmit = () => {
        const { email } = this.state;
        FirebaseAuthService.resetPassword(email)
            .then((obj) => {
                this.props.showMessage(obj);
            })
            .catch((erro) => {
                this.props.showMessage(erro);
            });
    };

    render() {
        const form = this.state;
        const { classes, theme } = this.props;

        return (
            <div className={clsx(classes.root, "flex flex-col flex-auto flex-shrink-0 md:flex-row p-0")}>
                <div className={clsx(classes.image, "flex-col flex-no-grow items-center text-white p-16 text-center md:p-128 md:flex-no-shrink md:flex-1 md:text-left justify-center")}>
                    <div className={classes.paper}>
                        <img
                            className={clsx(classes.bgTheme, "justify-center")}
                            src={`https://storage.googleapis.com/hexapp-public/logos/${document.location.hostname}/logo_${theme.palette.type}.png`}
                            alt="Logo principal"
                        />
                    </div>
                </div>

                <FuseAnimate animation={{ translateX: [0, "100%"] }}>
                    <Card className={classNames(classes.card, "w-full max-w-400 mx-auto m-16 md:m-0")} square>
                        <CardContent className={classNames(classes.content, "flex flex-col items-center justify-center py-32 m-28 md:m-36")}>
                            <img
                                id="logoPrincipal"
                                className={clsx(classes.bgTheme, "md:hidden sm:flex mb-12 h-52")}
                                src={`https://storage.googleapis.com/hexapp-public/logos/${document.location.hostname}/logo_${theme.palette.type}.png`}
                                alt="Logo principal"
                            />
                            <span className="font-medium text-16 my-32" >RECUPERAÇÃO DE CONTA</span>
                            <div className="flex flex-col justify-center w-full">
                                <TextField
                                    className="mb-16"
                                    label="Email"
                                    autoFocus
                                    type="email"
                                    name="email"
                                    value={form.email}
                                    onChange={this.handleChange}
                                    variant="outlined"
                                    required
                                    fullWidth
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />

                                <Button
                                    id="btn-reset-password"
                                    variant="contained"
                                    color="primary"
                                    className="w-224 mx-auto mt-16"
                                    aria-label="Reset"
                                    disabled={!this.isFormValid()}
                                    onClick={() => this.handleSubmit()}
                                >
                                    ENVIAR
                                </Button>

                            </div>

                            <div className="flex flex-col items-center justify-center pt-32 pb-24">
                                <Link id="link-login" className="font-medium" to="/pub-login">Fazer login em vez disso</Link>
                            </div>

                        </CardContent>
                    </Card>
                </FuseAnimate>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        showMessage: AppActions.showMessage,
    }, dispatch);
}

function mapStateToProps({ fuse }) {
    return {
        theme: fuse.settings.mainTheme
    };
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(ResetPasswordPage)));
